import { css } from "@compiled/react";

import Lozenge from "@atlaskit/lozenge";
import { B300, B400, N900 } from "@atlaskit/theme/colors";

import { ExpandableContent } from "../../../../expandable-content";
import { PlanFeatureMessage } from "../constants";

const planFeatureMessageContainerCss = css({
    display: "flex",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        "background": "none",
        "border": "none",
        "color": B300,
        "cursor": "pointer",
        "fontFamily": "Charlie Text",
        "fontSize": "0.875rem",
        "fontWeight": 400,
        "paddingLeft": "4px",
        "textAlign": "left",
        ":hover": {
            // eslint-disable-next-line local/ensure-wac-token-usage
            color: "#0049b0"
        }
    }
});

const contentContainerCss = css({
    color: N900,
    width: "100%"
});

const lozengeContainerCss = css({
    marginInlineStart: "4px"
});

const featureContentContainerCss = css({
    "fontSize": "0.875rem",
    "color": "#101214",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& a": {
        "color": B400,
        "textDecoration": "underline",
        "&:hover": {
            color: B300,
            textDecoration: "none"
        }
    }
});

const PlanFeature = ({
    featureMessage,
    lozengeText,
    padded = true
}: PlanFeatureMessage) => {
    const featureMessageHasContent = !(typeof featureMessage === "string");

    return (
        <div
            css={[
                planFeatureMessageContainerCss,
                padded &&
                    css({
                        paddingBlockStart: "16px",
                        paddingInlineStart: "10px"
                    })
            ]}
        >
            <div css={contentContainerCss}>
                {featureMessageHasContent ? (
                    <ExpandableContent
                        eventDataName={featureMessage.text}
                        label={
                            <span>
                                {featureMessage.text}
                                {lozengeText && (
                                    <span css={lozengeContainerCss}>
                                        <Lozenge>{lozengeText}</Lozenge>
                                    </span>
                                )}
                            </span>
                        }
                    >
                        <div css={featureContentContainerCss}>
                            {featureMessage.content("100%")}
                        </div>
                    </ExpandableContent>
                ) : (
                    <ExpandableContent
                        eventDataName={featureMessage}
                        label={
                            <span>
                                {featureMessage}
                                {lozengeText && (
                                    <span css={lozengeContainerCss}>
                                        <Lozenge>{lozengeText}</Lozenge>
                                    </span>
                                )}
                            </span>
                        }
                    />
                )}
            </div>
        </div>
    );
};

export { PlanFeature };
